import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuState } from './menu.types';
import { Menu } from '../../models/menu';

const initialState: MenuState = {
  menuId: null,
  menu: null,
  loading: false,
  error: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuId: (state, action: PayloadAction<string|null>) => {
      state.menuId = action.payload;
      state.loading = true;
    },
    setMenu: (state, action: PayloadAction<Menu>) => {
      state.menuId = action.payload.docId;
      state.menu = action.payload;
    },
    menuUpdated: (state, action: PayloadAction<Menu>) => {
      state.menu = action.payload;
      state.loading = false;
      state.error = null;
    },
    menuListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetMenu: (state) => {
      state.menu = null;
      state.loading = false;
      state.error = null;
    },
  }
});

export const {
  setMenuId,
  setMenu,
  menuUpdated,
  menuListenerError,
  resetMenu,
} = menuSlice.actions;

export default menuSlice.reducer;
